import { render, staticRenderFns } from "./org-allocate.vue?vue&type=template&id=6848a9b9&scoped=true"
import script from "./org-allocate.vue?vue&type=script&lang=ts"
export * from "./org-allocate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6848a9b9",
  null
  
)

export default component.exports